module.exports = __webpack_public_path__ + "img/22_old.d9c81e50.png";